<template>
    <InstitutionDialog
            :dialogTitle="dialogTitle"
            :centerDialogVisible="visible"
            @updateVisible="updateVisible"
            @resetPopupData="resetPopupData"
            @submitPopupData="submitPopupData"
            :popupWidth="'600px'"
    >
<!--        <div class="container-left">-->
<!--            <div class="container-left-title">组织机构</div>-->
            <div style="display: flex; flex-direction: row; align-items: center">部门：<el-input v-model="department" style="width: 200px"></el-input><el-button type="primary" style="width: 60px">搜索</el-button>
            </div>
        <div class="container-left">
            <el-tree
                    :data="treeData"
                    show-checkbox
                    class="container-tree"
            ></el-tree>
        </div>
<!--        </div>-->
    </InstitutionDialog>
</template>

<script>
    import InstitutionDialog from '../../../../components/common/epecDialog'
    export default {
        name: "institutionDialog",
        components: {
            InstitutionDialog
        },
        props: {
            dialogTitle:{
                type:String,
                required:true
            },
            visible:{
                type:Boolean,
                required: true
            }
        },
        data() {
            return {
                treeData:[{
                    id: 1,
                    label: '一级 1',
                    children: [{
                        id: 4,
                        label: '二级 1-1',
                        children: [{
                            id: 9,
                            label: '三级 1-1-1'
                        }, {
                            id: 10,
                            label: '三级 1-1-2'
                        }]
                    }]
                }, {
                    id: 2,
                    label: '一级 2',
                    children: [{
                        id: 5,
                        label: '二级 2-1'
                    }, {
                        id: 6,
                        label: '二级 2-2'
                    }]
                }, {
                    id: 3,
                    label: '一级 3',
                    children: [{
                        id: 7,
                        label: '二级 3-1'
                    }, {
                        id: 8,
                        label: '二级 3-2'
                    }]
                }],
                department:''
            }
        },
        computed: {},
        created() {
        },
        methods: {
            updateVisible(){

            },
            resetPopupData(){
                this.$emit('close')
            },
            submitPopupData(){

            },
        }

    }
</script>

<style lang="scss" scoped>
    .container-left{
        margin-top: 10px;
        width: 100%;
        .container-left-title{
            display: flex;
            justify-content: center;
            align-items: center;
            color: #000000;
            background: #dddddd;
            width: 100%;
            height: 50px;
            .container-tree{
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
        display: flex;
        flex-direction: column;
        background: #ffffff;
        border: 1px solid #dddddd;

    }
</style>
